export default "__VITE_ASSET__B406adas__"